module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('Autocomplete2', {

		configure: function (argument) {
			this.searchStr = '';
			this.responseData = [];
			this.inputTimer = null;
			this.filteredData = null;

			this.registerOptions('', {
				//useCache: false,
				searchParam: 'name',
				hightlightSelector: '.name',
				loadAll: false,
				staticFilter: false,
				filterParam: 'alias',

				widgets: {
					api: {
						widget: 'Api',
						method: 'Portal.searchModels'
					},

					input: {
						widget: 'Widget',
						autoRender: true,
						container: '.form-group.search',
						template: 'catalog_search_input'
					},

					list: {
						widget: 'List',
						autoRender: false,
						embed: {
							widget: '@parent #input',
							container: '[fox-autocomplete-result-list]'
						},
						'tpl.row': 'catalog_search_item',
						'hooks.onAddedToDom': fox.bind(function () {
							this._listAdded();
						}, this)
					}
				},

				handleWom: {
					handleApiStateChange: {
						widget: '#api',
						event: ['prepare', 'success', 'failure', 'loading', 'loaded', 'loadError'],
						callback: '_handleApiStateChange'
					},
					searchFailure: {
						widget: '@this',
						event: ['search_failure'],
						callback: '_handleSearchFailure'
					},
					searchSuccess: {
						widget: '@this',
						event: ['search_success'],
						callback: '_handleSearchSuccess'
					},
					itemSelected: {
						widget: '@this',
						event: ['item_selected'],
						callback: '_handleItemSelect'
					},
					inputEmptyState: {
						widget: '@this',
						event: ['inputEmpty', 'inputNotEmpty'],
						callback: '_handleInputEmptyState'
					}
				},

				handleDom: {
					selectFromList: {
						targetWidget: '#list',
						target: '[fox-autocomplete-result-item]',
						event: 'click',
						callback: '_handleSelectClick'
					},
					searchFormSubmit: {
						targetWidget: '#input',
						target: 'form[fox-autocomplete-form]',
						event: 'submit',
						callback: '_onFormSubmit'
					},
					searchFormSubmit2: {
						targetWidget: '#input',
						target: '.icon.search-start',
						event: 'click',
						callback: '_onFormSubmit'
					},
					inputChange: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'input',
						callback: '_handleInputChange'
					},
					clear: {
						targetWidget: '#input',
						target: '.icon.clear',
						event: 'click',
						callback: 'clear'
					},
					_bindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'focus',
						callback: '_bindKeyboardEvents'
					},
					// _bindKeyboardEvents2: {
					// 	targetWidget: '#input',
					// 	target: '[fox-autocomplete-input]',
					// 	click: 'click',
					// 	callback: function (el, alias, w, e) {
					// 		fox.dom.event.stop(e);

					// 		return false;
					// 	}
					// },
					_unbindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'blur',
						callback: '_unbindKeyboardEvents'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.rwom1('#api');
			this.input = this.rwom1('#input');
			this.resultList = this.rwom1('#list');
			this.hightlightSelector = this.getOption('hightlightSelector');
			this.useCache = false;
			this.isOpened = false;

			this.isFirstLoad = true;

			/*if (this.getOption('useCache')) {
				this.enableCache();
			}*/

			if (this.getOption('loadAll')) {
				this.loadAll();
			}

			//this._bindWindowEvents();

			this.callParent('running', arguments);
		},

		activate: function (argument) {
			//this._bindWindowEvents();

			this.callParent('activate', arguments);
			
			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		deactivate: function (argument) {
			//this._unbindWindowEvents();
			this.reset();
			this._hideList();
			this.callParent('deactivate', arguments);
		},

		reset: function (argument) {
			this.fillInput('');
			this.resultList.setCollection(this.responseData);

			this.searchStr = '';
			this.cachedData = {};

			this.isFirstLoad = true;

			if (!this.getOption('staticFilter')) {
				this.responseData = {};
				this.resultList.setCollection([]);
			}
		},

		enableCache: function () {
			this.clearCache();
			this.useCache = true;
		},

		disableCache: function () {
			delete this.cachedData;

			this.useCache = false;
		},

		clearCache: function () {
			this.cachedData = {};
		},

		getCachedData: function () {
			return this.cachedData;
		},

		prepareSearchParams: function (value) {
			var params = {};
			
			if (this.apiIsDl()) {
				//set params for datalayer

				return {};
			}

			params[this.getOption('searchParam')] = value;

			return params;
		},

		loadData: function (value) {
			var params = this.prepareSearchParams(value);

			if (this.apiIsDl()) {
				this.prepareSearchParams(value);
				this.api.load();

				return;
			}

			this.api.send(params);
		},

		_loadAll: function () {
			this.hookWrapper('loadAll');
		},

		loadAll: function () {
			this.loadData('');
			//this.waitEvent(this, ['search_success'], this._handleLoadAll)
		},

		search: function (value) {
			//this.searchStr = value;

			if (this.useCache && this.isInCache(value)) {
				this.getFromCache(value);

				return;
			}

			this.loadData(value);
		},

		clear: function () {
			this.fillInput('');
			this.clickedNode = null;
			this._hideList();
			this.dispatchEvent('search_form_submit');

			this.isFirstLoad = true;

			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		_onFormSubmit: function (el, w, alias, e) {
			fox.dom.event.stop(e);

			if (this.listPointer < 0) {
				this.dispatchEvent('search_form_submit');
				this.hideList();
			}

			return false;
		},

		getSearchString: function (argument) {
			return this.searchStr;
		},

		isInCache: function (value) {
			return this.cachedData[value] || false;
		},

		getFromCache: function (value) {
			////console.log('from cache', this.cachedData[value]);
			this.responseData = this.cachedData[value];

			this.dispatchEvent('search_success', this.responseData);
		},

		_handleApiStateChange: function (response, api, e) {
			if (fox.inArray(['prepare', 'loading'], e)) {
				this._showLoader();
				this.apiInProgress = true;

				return;
			}

			this._hideLoader();
			this.apiInProgress = false;

			var answer = response.answer;

			if (fox.inArray(['failure', 'error', 'loadError'], e)) {
				this.dispatchEvent('search_failure', answer);

				return;
			}

			if (this.useCache) {
				this.cachedData[this.searchStr] = answer.response;
			}

			this.responseData = this.apiIsDl() ? api.getCollection() : answer.response;

			this.isFirstLoad = false;

			this.hookWrapper('prepareResponse');

			if (!fox.isArray(this.responseData)) {
				this.responseData = fox.toArray(this.responseData);
			}

			if (!this.getOption('staticFilter')) {
				this.dispatchEvent('search_success', this.responseData);

				return;
			}

			this.filteredData = fox.clone(this.responseData);
			this.dispatchEvent('search_success', this.filteredData);
		},

		_showLoader: function () {
			this.dispatchEvent('loader_show');
			this.hookWrapper('toggleLoader', true);
		},

		_hideLoader: function () {
			this.dispatchEvent('loader_hide');
			this.hookWrapper('toggleLoader', false);
		},

		toggleLoader: function (state) {
			var loader = this.input.dom1('.preloader');

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', loader);
		},

		_showList: function () {
			if (!this.responseData.length) {
				return;
			}

			if (this.getOption('staticFilter') && !this.filteredData.length) {
				return;
			}

			this._bindWindowEvents();
			this.hookWrapper('showList');
			this.isOpened = true;
		},

		showList: function () {
			////console.warn('show list');
			fox.dom.addClass('show', this.input.dom1('.autocomplete-list'));
		},

		_hideList: function () {
			this.hookWrapper('hideList');
			this.isOpened = false;
			this._unbindWindowEvents();
		},

		hideList: function () {
			////console.warn('hide list');
			fox.dom.removeClass('show', this.input.dom1('.autocomplete-list'));
		},

		_handleSearchFailure: function (answer) {
			////console.warn(arguments);
		},

		_handleSearchSuccess: function (data) {
			this.renderResultList(data);
		},

		renderResultList: function (data) {
			this.resultList.setCollection(data, true);
		},

		_handleSelectClick: function (elm, alias, w, e) {
			fox.dom.event.stop(e);

			this.clickedNode = elm;
			this.dispatchEvent('item_selected', elm);

			if (this.getOption('staticFilter')) {
				return;
			}

			this._hideList();
		},

		_handleItemSelect: function (node) {
			this.hookWrapper('select', node);
		},

		_listAdded: function () {
			this.listPointer = -1;

			if (this.getOption('staticFilter')) {
				this._staticListAdded();

				return;
			}

			if (this.responseData && this.responseData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				if (this.getOption('loadAll') && this.isFirstLoad === true) {
					return;
				}

				if (this.isFocus) {
					this._showList();
				}
				
				this.hightlightResult();

				return;
			}

			this._hideList();
			this.resultItems = [];
		},

		_staticListAdded: function () {
			this.resultItems = [];

			if (!!this.filteredData && this.filteredData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				return;
			}

			this._hideList();
		},

		select: function (node) {
			this.dispatchEvent('search_form_submit');

			this.fillInput($(this.clickedNode).attr('fox-autocomplete-search-result'));
			this.hideList();
		},

		fillInput: function (str) {
			var elm = this.input.dom1('[fox-autocomplete-input]');
			elm[elm.tagName.toLocaleLowerCase() === 'input' ? 'value' : 'innerText'] = str;
			this.searchStr = str;

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');
		},

		_handleInputChange: function (el) {
			var str = el.tagName.toLocaleLowerCase() === 'input' ? fox.trim(el.value) : fox.trim(el.innerText);

			if (this.apiInProgress) {

				this.waitEvent(this.wom1('#api'), ['success', 'loaded'], fox.bind(function (argument) {
					this._handleInputChange(el);
				}, this));
				
				return;
			}

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');

			this.searchStr = str;

			if (this.getOption('staticFilter')) {
				this.filterData();
				
				return;
			}

			if (!str.length) {
				this._hideList();

				if (this.getOption('loadAll')) {
					this.loadAll();
				}
				
				return;
			}

			if (this.inputTimer) {
				window.clearInterval(this.inputTimer);
			}

			this.inputTimer = window.setTimeout(fox.bind(function (argument) {
				this.search(this.searchStr);
			}, this), 500);
		},

		hightlightResult: function () {
			if (!this.hightlightSelector) {
				return;
			}

			fox.each(this.resultItems, function (elt) {
				var $target = $(elt).find(this.hightlightSelector);
				var txt = $target.text();
				var matches = txt.match(new RegExp(this.searchStr, 'gi'));
				var split = txt.split(new RegExp(this.searchStr, 'gi'));
				var result = '';

				fox.each(matches, function (part, i) {
					result += split[i] + '<span class="hl hl-' + i + '">' + part + '</span>';
				}, this);

				if (matches) {
					result += split[matches.length];	
				}

				$target.html(result);
			}, this);
		},

		_close: function (e) {
			console.log('_close');
			var container = $(e.data.el);

			if (e.type === 'keyup') {
				if (e.keyCode && e.keyCode === 27) {
					e.data.widget._hideList();
				}

				return;
			}

			if (!container.length) {
				e.data.widget._hideList();

				return;
			}

			if (!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				e.data.widget.isOpened) {
					e.data.widget._hideList();
			}

		},

		_bindWindowEvents: function (argument) {
			var data = {widget: this};
			var elm = this.wom1('#input').dom1('form');

			if (elm) {
				data.el = elm;
			}

			$(window).on('click', data, this._close);
			$(window).on('keyup', data, this._close);
		},

		_unbindWindowEvents: function (argument) {
			$(window).off('click', this._close);
			$(window).off('keyup', this._close);
		},

		_bindKeyboardEvents: function () {
			$(window).on('keyup', {widget: this}, this._onKeyup);

			if (this.getOption('staticFilter') && this.filteredData.length) {
				this._showList();
			}

			this.isFocus = true;
		},

		_unbindKeyboardEvents: function (argument) {
			$(window).off('keyup', this._onKeyup);

			this.isFocus = false;
		},

		_onKeyup: function (e) {
			var _this = e.data.widget;
			e.preventDefault();

			if (e.keyCode === 38) {
				_this._kbPrev();
			}

			if (e.keyCode === 40) {
				//down
				_this._kbNext();
			}

			if (e.keyCode === 13) {
				_this._kbSelect();
			}

			return false;
		},

		_kbNext: function () {
			var pointer = ++this.listPointer;

			if (pointer >= this.responseData.length) {
				pointer = 0;
			}

			this._hightlight(pointer);

		},

		_kbPrev: function () {
			var pointer = --this.listPointer;

			if (pointer < 0) {
				pointer = this.responseData.length - 1;
			}

			this._hightlight(pointer);
		},

		_kbSelect: function () {
			if (this.listPointer < 0) {
				return;
			}

			this._handleSelectClick(this.resultItems[this.listPointer]);
		},

		_hightlight: function (ind) {
			this.listPointer = ind;
			this.hookWrapper('hightlight', ind);
		},

		hightlight: function (ind) {

			fox.each(this.resultItems, function (node, i) {
				fox.dom.removeClass('active', node);

				if (i === ind) {
					fox.dom.addClass('active', node);
					this._scrollList(node);
				}
			}, this);
		},

		_scrollList: function (node) {
			var top = $(node).position().top;

			$(this.resultList.element[0].parentNode).scrollTop(top);
		},

		getInputValue: function () {
			return this.wom1('#input').dom1('[fox-autocomplete-input]').value;
		},

		getValue: function () {
			return this.getInputValue();
		},

		apiIsDl: function () {
			return fox.oop.instanceOf(this.api, 'Datalayer');
		},

		filterData: function () {
			if (!this.searchStr.length) {
				this.filteredData = fox.clone(this.responseData);
			} else {
				var param = this.getOption('filterParam');
				this.filteredData = this.responseData.filter(function (obj) {
					if (obj[param] && obj[param].toLocaleLowerCase().match(this.searchStr)) {
						return true;
					}

					return false;
				}.bind(this));
			}

			this.renderResultList(this.filteredData);
		},

		prepareResponse: function () {
			fox.each(this.responseData, function (item) {
				if (fox.isString(item.id) && fox.isNumeric(item.id)) {
					item.id = window.parseInt(item.id);
				}
			});
		},

		_handleInputEmptyState: function (obj, w, e) {
			var cross = this.wom1('#input').dom1('.clear-field');

			if (!cross) {
				return;
			}

			fox.dom[(e === 'inputEmpty' ? 'removeClass' : 'addClass')]('show', cross);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/autocomplete2.js
// module id = 65
// module chunks = 0